import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Form, InputGroup, Dropdown, DropdownButton } from 'react-bootstrap';
import { COMPARISON_LABELS, Typography } from 'modules/common';

function WinRedAmountPredicateInput({
  title,
  onChange,
  name,
  value,
  predicateName,
  predicateValue,
  classNameFormGroup,
}) {
  const valuePredicateIcon = (COMPARISON_LABELS[predicateValue] || {}).icon || '';

  const _onChange = useCallback(
    event => {
      const newVal = event.target.value;
      /* Don't allow for values with more than 2 decimal places */
      if (!newVal.match(/\.\d\d\d+/)) onChange(event);
    },
    [onChange]
  );

  const _onChangePredicate = useCallback(
    value => onChange({ target: { name: predicateName, value } }),
    [onChange, predicateName]
  );

  const handleOnWheel = e => {
    e.target.blur();
    return;
  };

  return (
    <Form.Group className={classNameFormGroup}>
      {title ? (
        <Typography variant="bodyMedium" className="mb-1">
          {title}
        </Typography>
      ) : null}
      <InputGroup>
        <DropdownButton
          as={InputGroup.Prepend}
          variant="outline-primary"
          title={valuePredicateIcon}
          className="amount-predicate"
        >
          {Object.entries(COMPARISON_LABELS).map(([key, value]) => (
            <Dropdown.Item onSelect={_onChangePredicate} eventKey={key} key={key}>
              {value.icon}
            </Dropdown.Item>
          ))}
        </DropdownButton>
        <div className="input-group-prepend input-group-append">
          <InputGroup.Text>$</InputGroup.Text>
        </div>
        <Form.Control
          value={value || ''}
          type="number"
          inputMode="decimal"
          pattern="\d*"
          className="winred-input input-with-prepend"
          name={name}
          onChange={_onChange}
          onWheel={handleOnWheel}
        />
      </InputGroup>
    </Form.Group>
  );
}

WinRedAmountPredicateInput.propTypes = {
  title: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  classNameFormGroup: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  predicateName: PropTypes.string.isRequired,
  predicateValue: PropTypes.string.isRequired,
};

export default WinRedAmountPredicateInput;
